import { render, staticRenderFns } from "./HighNetWorth.vue?vue&type=template&id=636f073e"
import script from "./HighNetWorth.vue?vue&type=script&lang=js"
export * from "./HighNetWorth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports